import Model from '@/models/Model.js';

export default class VideoGroup extends Model {
    static entity = 'video_group';

    static modelName = 'VideoGroup';

    static primaryKey = ['video_id', 'group_id'];

    static fields() {
        return {
            id: this.attr(null),
            video_id: this.attr(null),
            group_id: this.attr(null),

            ...super.fields(),

            video: this.belongsTo('videos', 'video_id'),
            group: this.belongsTo('groups', 'group_id'),
        };
    }
}
